import React from "react";
import classNames from "classnames";

export function KurdishSymbolA({ className = "", ...rest }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      clipRule="evenodd"
      viewBox="326.496 320.871 39.469 42.156"
      className={classNames("illustration kurdi-1", className)}
      {...rest}
    >
      <clipPath id="kurdi_1">
        <path d="M326.496 320.871H365.965V363.027H326.496z"></path>
      </clipPath>
      <g clipPath="url(#kurdi_1)">
        <path
          fill="currentColor"
          d="M355.121 320.871l-.562.531-8.156 8.187-8.688-8.687-1.937 1.906-.469.469-8.5 8.531 2.375 2.375 2.375 2.375 2.406 2.375 7.594-7.594-2.375-2.375-5.219 5.219-2.375-2.375 6.125-6.125 6.313 6.313-9.719 9.656.031.031-.156.125 10.062 10.063-6.468 6.468-6.5-6.5 2.468-2.437 5.219 5.219 2.406-2.375-5.25-5.25-2.406-2.407-7.219 7.25.188.157 11.031 11.031.094-.063.062.063 8.782-8.75 8.531 8.531 1.469-1.5.687-.687.219-.219 6.687-6.688 1.719-1.718-5-4.969-2.375-2.406-2.375 2.406-5.219 5.219 2.375 2.375 5.219-5.219 2.625 2.625-6.031 6-6.156-6.156 9.843-9.844-.375-.375-2.031-2-7.656-7.688 6.312-6.312 6 6-2.625 2.656-5.125-5.125-2.375 2.375 7.469 7.5.156-.156 4.875-4.875 2.407-2.375-10.782-10.781zm-8.718 13.5l7.687 7.687-7.469 7.438-7.656-7.688 7.438-7.437zm.031 3l-4.625 4.656 4.656 4.656 4.625-4.656-4.656-4.656z"
        ></path>
      </g>
    </svg>
  );
}

export function KurdishSymbolB({ className, ...rest }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      clipRule="evenodd"
      className={classNames("illustration kurdi-2", className)}
      viewBox="324.731 252.696 43 42.969"
      {...rest}
    >
      <clipPath id="kurdi_2">
        <path d="M324.731 252.696H367.731V295.665H324.731z"></path>
      </clipPath>
      <g clipPath="url(#kurdi_2)">
        <path
          fill="currentColor"
          d="M342.481 252.696v8.469h-9.25v9.25h-8.5v7.531h8.5v9.25h9.25v8.469h7.5v-8.469h9.25v-9.25h8.5v-7.531h-8.5v-9.25h-9.25v-8.469h-7.5zm1.125 13.344h5.25v5.5h5.5v5.25h-5.5v5.5h-5.25v-5.5h-5.5v-5.25h5.5v-5.5z"
        ></path>
      </g>
    </svg>
  );
}

export function KurdishSymbolC({ className, ...rest }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      clipRule="evenodd"
      className={classNames("illustration kurdi-3", className)}
      viewBox="207.351 317.718 50.719 42.688"
      {...rest}
    >
      <clipPath id="kurdi_3">
        <path d="M207.351 317.718H258.07V360.406H207.351z"></path>
      </clipPath>
      <g clipPath="url(#kurdi_3)">
        <path
          fill="currentColor"
          d="M221.57 317.718l5.594 6.875.875 1.062h-13.406l4.937 5.781h-12.219l5.625 7.625-5.625 7.625h12.219l-4.937 5.782h13.375l-.875 1.062-5.563 6.875h22.281l-5.593-6.875-.875-1.062h13.406l-4.938-5.782h12.219l-5.625-7.625 5.625-7.625h-12.219l4.938-5.781h-13.375l.875-1.062 5.562-6.875H221.57zm10.875 14.843l6.5 6.5-6.5 6.5-6.5-6.5 6.5-6.5z"
        ></path>
      </g>
    </svg>
  );
}

export function KurdishSymbolD({ className, ...rest }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={classNames("illustration kurdi-4", className)}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      clipRule="evenodd"
      viewBox="270.481 382.721 39.281 42.531"
      {...rest}
    >
      <clipPath id="kurdi_4">
        <path d="M270.481 382.721H309.762V425.252H270.481z"></path>
      </clipPath>
      <g clipPath="url(#kurdi_4)">
        <path
          fill="currentColor"
          d="M290.262 382.721l-19.781 19.75 7.344 7.312 7.218-7.187h-7.281l2.656-3 2.657-3 2.656 3 2.687 3-10.406 10.406 12.25 12.25 12-12.031-10.656-10.625 2.687-3 2.657-3 2.656 3 2.656 3H294.981l7.219 7.187 7.562-7.562-19.5-19.5zm0 7.562l3.375 3.375-3.375 3.406-3.406-3.406 3.406-3.375zm-.125 17.031l5.375 5.407-5.375 5.375-5.406-5.375 5.406-5.407z"
        ></path>
      </g>
    </svg>
  );
}

const Symbols = [
  KurdishSymbolA,
  KurdishSymbolB,
  KurdishSymbolC,
  KurdishSymbolD,
];

export default function KurdishSymbol({ index = 0, className, ...rest }) {
  const i = index % Symbols.length;
  const S = Symbols[i];

  return <S className={className} {...rest} />;
}
